import globalAxios, { type AxiosInstance, type AxiosPromise, type AxiosRequestConfig } from 'axios';
import type { Configuration } from './configuration';
import { BASE_PATH, BaseAPI } from './base';
import type { BaseMenuAdminVo, BaseOrderByVo, ResultVo } from './api';

export interface BusinessMenuListRequest {
  conditions?: Partial<BaseMenuAdminVo>;
  orderBys?: BaseOrderByVo[];
  queryKey?: string;
}

export interface BusinessMenuMoveRequest {
  menuId: number;
  targetMenuId: number;
  mode: 'before' | 'after' | 'child';
}

export interface BusinessMenuDirectoryRequest {
  title: string;
  sequence?: number;
  icon?: string;
  parentId?: number;
}

export class BusinessMenuApi extends BaseAPI {

  constructor(
    configuration?: Configuration,
    basePath: string = BASE_PATH,
    axios: AxiosInstance = globalAxios,
  ) {
    super(configuration, basePath, axios);
  }

  public listMenus(
    businessMenuListRequest: BusinessMenuListRequest = {},
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'POST',
      url: `${this.basePath}/businessMenu/listBusinessMenus`,
      headers: {
        'Content-Type': 'application/json',
        ...((options && options.headers) || {}),
      },
      data: businessMenuListRequest,
    });
  }

  public addDirectory(
    directoryRequest: BusinessMenuDirectoryRequest,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'POST',
      url: `${this.basePath}/businessMenu/addBusinessMenuDirectory`,
      headers: {
        'Content-Type': 'application/json',
        ...((options && options.headers) || {}),
      },
      data: directoryRequest,
    });
  }

  public deleteDirectory(
    menuId: number,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'DELETE',
      url: `${this.basePath}/businessMenu/delBusinessMenuDirectory`,
      params: { menuId },
    });
  }

  public updateMenu(
    baseMenuAdminVo: Partial<BaseMenuAdminVo>,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'PUT',
      url: `${this.basePath}/businessMenu/updateBusinessMenu`,
      headers: {
        'Content-Type': 'application/json',
        ...((options && options.headers) || {}),
      },
      data: baseMenuAdminVo,
    });
  }

  public moveMenu(
    moveRequest: BusinessMenuMoveRequest,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'PUT',
      url: `${this.basePath}/businessMenu/moveBusinessMenu`,
      headers: {
        'Content-Type': 'application/json',
        ...((options && options.headers) || {}),
      },
      data: moveRequest,
    });
  }

}
